import React, { FC } from 'react';

import TimerClockCircle from '../ClockCircle';
import { BasicCommandType } from '../config';

export type IPauseTimerProps = BasicCommandType;

const PauseTimer: FC<IPauseTimerProps> = (props) => (
  <TimerClockCircle
    {...props}
    $isDark
    $isActive
  />
);

export default PauseTimer;
